import { render, staticRenderFns } from "./SaleClose.vue?vue&type=template&id=6ba5511e&scoped=true&"
import script from "./SaleClose.vue?vue&type=script&lang=js&"
export * from "./SaleClose.vue?vue&type=script&lang=js&"
import style0 from "./SaleClose.vue?vue&type=style&index=0&id=6ba5511e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba5511e",
  null
  
)

export default component.exports